'use client';

import PageElement from '../../../components/PageElements/PageElement';
import { useVal, useValRoute } from '../../../val/val.client';
import LargeLayout from '../../../containers/LargeLayout';
import ContactSales from '../../../components/ContactSales/ContactSales';
import WideProjectElement from '../../../components/ProjectElement/WideProjectElement';
import DoubleProjectElement from '../../../components/ProjectElement/DoubleProjectElement';
import { getAllActiveProjects } from '../../../utils/getAllActiveProjects';
import allProjectsVal from './[slug]/page.val';
import { ValEncodedString } from '@valbuild/next';
import pageVal from './page.val';
import { notFound } from 'next/navigation';

const Arbeider = ({ params }: { params: Promise<never> }) => {
  const page = useValRoute(pageVal, params);
  const allProjects = useVal(allProjectsVal);

  if (!page) {
    return notFound();
  }
  const allActiveProjects = getAllActiveProjects(allProjects, page);
  const { links: currentProjects, header, subheader, pageElements } = page;

  return (
    <>
      <div id="arbeider" className="bg-blank-black text-blank-yellow">
        <LargeLayout>
          <div className="w-full">
            <div className="flex flex-col tablet:flex-row-reverse justify-between gap-32 tablet:gap-128 mb-128">
              <h1 className="text-lg tablet:text-xl shrink-0">{header}</h1>
              <h2 className="font-respira text-respira-lg md:w-2/3 tablet:text-respira-xl">
                {subheader}
              </h2>
            </div>
          </div>

          {currentProjects.map((project, idx) => {
            const projectRef = allActiveProjects[project];
            if (!projectRef) {
              return null;
            }

            const patternPosition = idx % 3;
            const isPriority = idx < 3;

            if (patternPosition === 0) {
              const nextProject = currentProjects[idx + 1];
              const nextProjectRef = nextProject
                ? allActiveProjects[nextProject]
                : null;

              if (!nextProjectRef) {
                return (
                  <DoubleProjectElement
                    type="doubleProjectElement"
                    priority={isPriority}
                    key={idx}
                    leftProject={{
                      type: 'projectElement',
                      image: projectRef.thumbnail,
                      projectTitle: projectRef.hero.title,
                      clientName: projectRef.hero.projectSummary.client,
                      url: project as ValEncodedString,
                      services: projectRef.hero.projectSummary.services,
                    }}
                    rightProject={null}
                    reverseOrder={(idx / 3) % 2 === 1}
                    alignSquareToTop={idx === 0}
                  />
                );
              }

              return (
                <DoubleProjectElement
                  type="doubleProjectElement"
                  priority={isPriority}
                  key={idx}
                  leftProject={{
                    type: 'projectElement',
                    image: projectRef.thumbnail,
                    projectTitle: projectRef.hero.title,
                    clientName: projectRef.hero.projectSummary.client,
                    url: project as ValEncodedString,
                    services: projectRef.hero.projectSummary.services,
                  }}
                  rightProject={{
                    type: 'projectElement',
                    image: nextProjectRef.thumbnail,
                    projectTitle: nextProjectRef.hero.title,
                    clientName: nextProjectRef.hero.projectSummary.client,
                    url: nextProject as ValEncodedString,
                    services: nextProjectRef.hero.projectSummary.services,
                  }}
                  reverseOrder={(idx / 3) % 2 === 1}
                  alignSquareToTop={idx === 0}
                />
              );
            } else if (patternPosition === 2) {
              return (
                <WideProjectElement
                  priority={isPriority}
                  key={idx}
                  type={'wideProjectElement'}
                  image={projectRef.hero.image}
                  projectTitle={projectRef.hero.title}
                  clientName={projectRef.hero.projectSummary.client}
                  url={project as ValEncodedString}
                  services={projectRef.hero.projectSummary.services}
                />
              );
            }
          })}

          {pageElements.map((element, i) => {
            return <PageElement key={i} element={element} />;
          })}
          <ContactSales />
        </LargeLayout>
      </div>
    </>
  );
};

export default Arbeider;
